<section class="content-layout right-sidebar-fullheight-basic-inner-scroll flex flex-row">
  <article class="sidebar">
    <header class="sidebar__header">
      @if (propertyUnits.length > 0 && selectedPropertyUnit) {
        <mat-form-field class="unit-selector" data-cy="property-unit-dropdown">
          <mat-select
            [(ngModel)]="selectedPropertyUnitId"
            (selectionChange)="onSelectionChange($event)"
            data-cy="property-units-selector"
          >
            @for (propertyUnit of propertyUnits; track propertyUnit.id) {
              <mat-option [value]="propertyUnit.id"> Unit: {{ unitName(propertyUnit) }} </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (propertyUnits.length === 0) {
        <p>Add Unit</p>
      }

      <button
        mat-icon-button
        (click)="addUnit()"
        [matTooltip]="'Add Unit'"
        data-cy="add-property-unit-button"
        [appAuthorize]="NewPermission.LEASES_CREATE"
        denyAction="disable"
      >
        <mat-icon [svgIcon]="'add_circle_outline'"></mat-icon>
      </button>
    </header>

    @if (propertyUnits.length > 0 && selectedPropertyUnit) {
      <main class="sidebar__body">
        <div class="light:bg-cool-gray-100 dark:bg-cool-gray-700 pl-3 pr-3 pt-2 pb-2 border-b flex items-center">
          @if (editMode) {
            <div class="flex items-center flex-auto">
              <app-form-field
                [fieldDef]="titleFieldDef"
                [model]="selectedPropertyUnit"
                (onUpdate)="update($event)"
                [readonly]="!canEdit()"
              ></app-form-field>
            </div>
          }
          <div class="flex flex-col">
            @if (!editMode) {
              <div class="font-bold text-md text-secondary uppercase tracking-wider">Details</div>
            }
          </div>
          <div class="ml-auto">
            @if (!(editMode || isLayoutChange)) {
              <button
                [appAuthorize]="NewPermission.LEASES_MANAGE_ADD_FORM"
                mat-icon-button
                type="button"
                [matMenuTriggerFor]="listCardMenu"
              >
                <mat-icon class="icon-size-20" [svgIcon]="'more_vert'"></mat-icon>
              </button>
              <mat-menu #listCardMenu="matMenu">
                <button mat-menu-item (click)="toggleEditMode()" type="button">
                  <mat-icon [svgIcon]="'edit'"></mat-icon>
                  Edit Layout
                </button>
                <button mat-menu-item (click)="changeLayout()">
                  <mat-icon [svgIcon]="'sync_alt'"></mat-icon>
                  Re-arrange Fields
                </button>
              </mat-menu>
            }

            @if (editMode || isLayoutChange) {
              <button mat-icon-button type="button" [matTooltip]="'Cancel'" (click)="cancelEdits()">
                <mat-icon [svgIcon]="'cancel'"></mat-icon>
              </button>
            }

            @if (editMode && (!fields || fields.length <= 0)) {
              <button mat-icon-button type="button" [matTooltip]="'Add Row'" #addContactPanelOrigin (click)="addRow()">
                <mat-icon [svgIcon]="'add_circle'"></mat-icon>
              </button>
            }

            @if (editMode || isLayoutChange) {
              <button mat-icon-button type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
                <mat-icon [svgIcon]="'save'"></mat-icon>
              </button>
            }
          </div>
        </div>

        <div class="flex flex-col py-4 pl-4 pr-2">
          @if (isLayoutChange) {
            <div class="flex flex-row boundary" cdkDropListGroup>
              @for (fieldCol of fieldsCombined; track fieldCol; let idx = $index) {
                <div
                  class="w-full"
                  (cdkDropListDropped)="dropped($event)"
                  cdkDropList
                  [cdkDropListData]="fieldCol"
                  cdkDragBoundary=".boundary"
                >
                  @for (fieldName of fieldCol; track fieldName) {
                    <div
                      class="flex items-center w-full"
                      cdkDrag
                      [cdkDragData]="fieldName"
                      *ngIf="lookupField(fieldName) as fieldDef"
                    >
                      <app-form-field
                        class="w-full"
                        [fieldDef]="fieldDef"
                        [model]="selectedPropertyUnit"
                        (onUpdate)="update($event)"
                        [data]="data"
                        [readonly]="!canEdit()"
                      >
                      </app-form-field>
                      <button mat-icon-button [matTooltip]="'Drag me'" cdkDragHandle>
                        <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          } @else {
            @if (!editMode) {
              @for (fieldRow of fields; track fieldRow) {
                <div class="flex flex-col">
                  @for (fieldName of fieldRow; track fieldName) {
                    <ng-container *ngIf="lookupField(fieldName) as fieldDef">
                      <app-form-field
                        [fieldDef]="fieldDef"
                        [model]="selectedPropertyUnit"
                        (onUpdate)="update($event)"
                        [data]="data"
                        [readonly]="!canEdit()"
                      ></app-form-field>
                    </ng-container>
                  }
                </div>
              }
            } @else {
              @for (fieldRow of fields; track fieldRow; let rowIndex = $index, firstRow = $first, lastRow = $last) {
                <div class="flex flex-col gt-xs:flex-row items-center">
                  @for (
                    fieldName of fieldRow;
                    track fieldName;
                    let colIndex = $index, firstCol = $first, lastCol = $last
                  ) {
                    <ng-container *ngIf="lookupField(fieldName) as fieldDef">
                      <div class="flex-auto">
                        <select-field
                          [data]="data"
                          [fieldDef]="fieldDef"
                          type="PropertyUnit"
                          (update)="onFieldSelectionChange($event, rowIndex, colIndex)"
                          [model]="panelDef"
                          [rowIndex]="rowIndex"
                          [colIndex]="colIndex"
                        >
                        </select-field>
                      </div>
                    </ng-container>
                    @if (!(firstRow && lastRow)) {
                      <button
                        type="button"
                        mat-icon-button
                        (click)="removeField(rowIndex, colIndex)"
                        matTooltip="Remove"
                      >
                        <mat-icon [svgIcon]="'cancel'"></mat-icon>
                      </button>
                    }
                    @if (lastRow && lastCol) {
                      <button type="button" mat-icon-button (click)="addRow()" matTooltip="Add">
                        <mat-icon [svgIcon]="'library_add'"></mat-icon>
                      </button>
                    }
                  }
                </div>
              }
            }
          }
        </div>
      </main>
    }
  </article>

  @if (propertyUnits && propertyUnits.length > 0) {
    <router-outlet></router-outlet>
  }
</section>
